import React, { useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/home";
import ContactPage from "./pages/contact";
import DonatorsPage from "./pages/donators";
import TeamPage from "./pages/team";
import JoinPage from "./pages/join";
import ProjectPage from "./pages/project";

import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Router>
      <ScrollToTop />
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/contact" element={<ContactPage />} />
        <Route exact path="/donators" element={<DonatorsPage />} />
        <Route exact path="/join" element={<JoinPage />} />
        <Route exact path="/project" element={<ProjectPage />} />
        <Route exact path="/team" element={<TeamPage />} />
        {/* if wrong path redirect to the main page */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
